import { STATUS } from "@/constants/statuses";
import { QueryEntity } from "@datorama/akita";
import { map } from "rxjs/operators";
import { injectable } from "tsyringe";

import { ProductsState, ProductsStore } from "../stores/ProductsStore";

@injectable()
export class ProductsQuery extends QueryEntity<ProductsState> {
    public constructor(private readonly productsStore: ProductsStore) {
        super(productsStore);
    }

    all$ = this.selectAll();
    statuses$ = this.select((state) => state.productStatuses);

    public selectProductIds() {
        return this.select((state) => state.ids).pipe(map((ids) => ids ?? []));
    }

    public selectProductInLoadingStatus(productId: number) {
        return this.select((state) => state.productStatuses).pipe(
            map((statusItems) => {
                return (
                    statusItems.find(
                        (statusItem) => statusItem.productId === productId
                    )?.status === STATUS.LOADING
                );
            })
        );
    }

    public selectProductStatus(productId: number) {
        return this.select(
            (state) =>
                state.productStatuses.find(
                    (statusItem) => statusItem.productId === productId
                )?.status
        );
    }

    public selectProduct(productId: number) {
        return this.selectAll().pipe(
            map((products) =>
                products.find((product) => product.id === productId)
            ),
            map((product) => product || null)
        );
    }

    public selectProductAndVariant(
        productId: number,
        variantId: number | null
    ) {
        return this.selectAll().pipe(
            map((products) =>
                products.find((product) => product.id === productId)
            ),
            map((product) => ({
                product: product,
                variant: product?.variants.find((variant) => {
                    if (!variantId) {
                        return true;
                    }
                    return variant.id === variantId;
                }),
            }))
        );
    }

    public selectFirstVariantOfProduct(productId: number) {
        return this.selectProduct(productId).pipe(
            map((product) => {
                if (product?.variants.length) {
                    return product?.variants[0];
                }

                return null;
            })
        );
    }
}
